export const PuestosInitial = {
    name: "",
};